export const scaleColor = ['20', '40', '60', '80', '100'];